module.exports = __webpack_public_path__ + "static/media/gotham-medium.1c769a17.woff";